// React & Libraries
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

// Ant Design
import { Drawer, Alert, } from 'antd';

// Constants & Helpers
import { entityNameEnum } from '@Apis/constants';
import Helpers from '@Apis/helpers';
import documentUINamesConstant from '../../../../apis/documentUINamesConstant';

// Actions
import DCActions from '@Actions/dcActions';
import AttachmentActions from '@Actions/attachmentActions';
import AnalyticsActions from '@Actions/application/analyticsActions';
import ActivityLogActions from '@Actions/activityLogActions';
import quickUpdateActions from '../../../../actions/quickUpdate/quickUpdateActions';

// Components
import EwaybillForm from '@Components/Sales/EinvoicingEwaybill/EwaybillList/EwaybillForm';
import ViewDocumentEwb from '@Components/Common/ViewDocumentEwb';
import InvoiceForm from '../../../Sales/Invoice/InvoiceForm';
import DeliveryChallanForm from '../DeliveryChallanForm';
import ViewLoadingSkull from '../../../Common/ViewLoadingSkull';
import AddressSelector from '@Components/Common/FormUtils/AddressSelecter';
import ViewDocRightSection from '@Components/Common/ViewDocRightSection';
import PRZDrawer from '@Components/Common/UI/PRZDrawer';

// Assets & Styles
import './style.scss';

// Local Components
import DCLines from './DCLines';
import ViewDCLeftSectionHeader from './ViewDCLeftSectionHeader';
import ViewDCLeftSectionDocDetails from './ViewDCLeftSectionDocDetails';
import ViewDCLeftSectionAddress from './ViewDCLeftSectionAddress';
import ViewDCFooter from './ViewDCFooter';

function ViewDeliveryChallan(props) {

  const {
    selectedDCId,
    getDCById,
    user,
    match,
    selectedDC,
    selectedAttachment,
    getAttachmentByIdLoading,
    updateAttachmentLoading,
    getDCByIdSuccess,
    updateAttachment,
    getAttachmentById,
    getDCByIdLoading,
    selectedDocType,
    MONEY,
    isQuickView,
    priceMasking,
    updateDCWorkflowStep,
    updateDCWorkflowStepLoading,
    getActivityLog,
    quickUpdateEntityWise,
  } = props;

  const [state, setState] = useState({
    currentUpdate: '',
    isGetAttachment: false,
    showEWaybillFormDrawer: false,
    showDCDrawer: false,
    showNewInvoiceForm: false,
    showAddressDrawer: false,
    selectedAddressType: '',
    driverInfoFields: ['transporter_name', 'vehicle_type', 'vehicle_number', 'shipment_weight', 'driver_name', 'driver_phone', 'e_way_bill_number'],
    documentUINames: {},
  });

  const updateState = (newState) => {
    setState((oldState) => ({
      ...oldState,
      ...newState,
    }));
  };

  const {
    isGetAttachment,
    showEWaybillFormDrawer,
    showDCDrawer,
    showNewInvoiceForm,
    updatedGstNumber,
    showAddressDrawer,
    selectedAddressType,
    dataForViewDCLines,
    cfDeliveryChallanLine,
  } = state;

  useEffect(() => {

    if (selectedDCId) {
      getDCById(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.DELIVERY_CHALLAN, Helpers.permissionTypes.READ).join(','), selectedDCId || match.params?.dcId);
    }

    return () => {
      getDCByIdSuccess(null);
    };
  }, []);

  useEffect(() => {

    if (user?.tenant_info?.tenant_id) {
      if (window.location.href.includes('/inventory/delivery-challan/view') && match?.params?.dcId) {
        getDCById(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.DELIVERY_CHALLAN, Helpers.permissionTypes.READ).join(','), match?.params?.dcId);
      }
    }

    updateState({
      documentUINames: documentUINamesConstant(user),
    });
  }, [user]);

  useEffect(() => {

    updateState({
      fileList: selectedDC?.attachments,
      isUserReadyForPrefillData: true,
      updatedGstNumber: selectedDC?.gst_number,
      dataForViewDCLines: selectedDC?.delivery_challan_lines?.map(item => ({
        ...item,
        key: uuidv4(),
      })),
      cfDeliveryChallanLine: selectedDC?.delivery_challan_lines?.[0]?.custom_fields,
    });
  }, [selectedDC]);

  useEffect(() => {

    if (selectedAttachment && isGetAttachment && !getAttachmentByIdLoading && !updateAttachmentLoading) {

      updateState({
        fileList: selectedAttachment,
        isGetAttachment: false,
      });
    }
  }, [selectedAttachment, isGetAttachment, getAttachmentByIdLoading, updateAttachmentLoading]);

  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  const fixedMenuBar = user?.side_menu_bar_type === 'FIXED';

  const getRecipient = () => {

    if (selectedDC?.adhoc_dc_customer_id) return { recipient: selectedDC?.adhoc_dc_customer_info?.legal_name || selectedDC?.adhoc_dc_customer_info?.customer_name, type: 'CUSTOMER' };
    if (selectedDC?.customer_name) return { recipient: selectedDC?.customer_name || selectedDC?.legal_name, type: 'CUSTOMER INVOICE' };
    if (selectedDC?.adhoc_dc_seller_id) return { recipient: selectedDC?.adhoc_dc_seller_info?.seller_name, type: 'VENDOR' };
    if (selectedDC?.adhoc_dc_dest_tenant_id) return { recipient: selectedDC?.adhoc_dc_dest_tenant_info?.tenant_name, type: 'INTERNAL' };
    if (selectedDC?.stock_transfer_id) return { recipient: selectedDC?.destination_tenant_department_info?.destination_tenant_name, type: 'INTERNAL' };
  };

  const HideAdhocApprovals = () => {
    if (selectedDC?.workflow_steps) {
      const steps = Object?.values(selectedDC?.workflow_steps)?.filter((step) => step !== null);
      const pendingSteps = steps?.filter((step) => step?.status === 'PENDING');
      return steps?.length < 10 && pendingSteps?.length === steps?.length;
    }
    return false;
  };

  const getEntityForAddressSelector = (selectedAddressType) => {
    const entity = getRecipient()?.type;
    if (entity === "CUSTOMER") {
      return {
        entityId: selectedAddressType === "SOURCE" ? selectedDC?.tenant_id : selectedDC?.customer_id,
        entityType: selectedAddressType === "SOURCE" ? "TENANT" : "CUSTOMER",
      };
    } else if (entity === "CUSTOMER INVOICE") {
      return {
        entityId: selectedAddressType === "SOURCE" ? selectedDC?.tenant_id : selectedDC?.customer_id,
        entityType: selectedAddressType === "SOURCE" ? "TENANT" : "CUSTOMER",
      };
    } else if (entity === "VENDOR") {
      return {
        entityId: selectedAddressType === "SOURCE" ? selectedDC?.tenant_id : selectedDC?.adhoc_dc_seller_id,
        entityType: selectedAddressType === "SOURCE" ? "TENANT" : "SELLER",
      };
    } else if (entity === "INTERNAL") {
      return {
        entityId:
          selectedAddressType === "SOURCE"
            ? selectedDC?.source_department_info?.tenant_id || //from st
            selectedDC?.tenant_id //from adhoc
            : selectedDC?.destination_tenant_department_info?.tenant_id || //from st
            selectedDC?.adhoc_dc_dest_tenant_id, //from adhoc
        entityType: "TENANT",
      };
    }
  };

  const getLinkedDocumentInfo = () => {

    let linkedDocumentsInfo = [];

    if (selectedDC?.invoice_info?.length > 0) {

      let documentDataInfo = [];
      selectedDC?.invoice_info?.forEach((item) => {
        documentDataInfo.push({
          documentId: item?.invoice_id,
          documentNumber: item?.invoice_number,
          documentStatus: item?.status,
          documentTotal: item?.invoice_total,
        });
      });

      const invoiceDataInfo = {
        entityName: entityNameEnum.INVOICE,
        entityVisible: Helpers.getPermission(Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.READ, user) && selectedDC?.status === 'CONFIRMED',
        title: 'INVOICES',
        entityNumberPrefix: "",
        documentData: documentDataInfo,
        isRedirect: true,
        redirectPath: '/sales/invoice/view/',
        hidePrice: isDataMaskingPolicyEnable && isHideCostPrice,
        popOverMessage: "You don't have access to view amount",
        showEntityTotal: true,
      };
      linkedDocumentsInfo.push(invoiceDataInfo);
    }

    return linkedDocumentsInfo;
  };

  return (
    <div className={`view-document__wrapper ${!isQuickView ? 'view-document__wrapper-page' : ""}`}>
      <Drawer
        open={showAddressDrawer}
        onClose={() => updateState({ showAddressDrawer: false, selectedAddressType: '' })}
        width="360"
        destroyOnClose
      >
        <AddressSelector
          title={selectedAddressType === 'SOURCE' ? 'Source Address' : 'Destination Address'}
          addressType={selectedAddressType}
          selectedAddressId={selectedAddressType === 'SOURCE' ? selectedDC?.source_address_id : selectedDC?.destination_address_id}
          onAddressChange={(address) => {
            if (selectedAddressType === 'DESTINATION') {
              quickUpdateEntityWise({
                destination_address_id: address?.address_id,
                delivery_challan_id: selectedDC?.delivery_challan_id,
                entity_name: 'DELIVERY_CHALLAN',
              }, () => {
                updateState({ showAddressDrawer: false });
                getDCById(selectedDC?.tenant_id, selectedDC?.delivery_challan_id, () => {
                  getActivityLog(selectedDC?.delivery_challan_id, 'delivery_challan', 1, 10);
                });
              }, () => {
                updateState({ showAddressDrawer: false });
                getDCById(selectedDC?.tenant_id, selectedDC?.delivery_challan_id);
              });
            } else if (selectedAddressType === 'SOURCE') {
              quickUpdateEntityWise({
                source_address_id: address?.address_id,
                delivery_challan_id: selectedDC?.delivery_challan_id,
                entity_name: 'DELIVERY_CHALLAN',
              }, () => {
                updateState({ showAddressDrawer: false });
                getDCById(selectedDC?.tenant_id, selectedDC?.delivery_challan_id, () => {
                  getActivityLog(selectedDC?.delivery_challan_id, 'delivery_challan', 1, 10);
                });
              }, () => {
                updateState({ showAddressDrawer: false });
                getDCById(selectedDC?.tenant_id, selectedDC?.delivery_challan_id);
              });
            }
          }}
          entityId={getEntityForAddressSelector(selectedAddressType)?.entityId}
          entityType={getEntityForAddressSelector(selectedAddressType)?.entityType}
          tenantId={selectedDC?.tenant_id}
        />
      </Drawer>
      {!(getDCByIdLoading)
        ? (
          <div className="ant-row">
            <div className={`${fixedMenuBar ? 'ant-col-md-16' : 'ant-col-md-17'} ant-col-xs-24`}>
              <div className={`view-left__wrapper ${!isQuickView ? 'is-page-view' : ''}`}>
                <ViewDCLeftSectionHeader
                  state={state}
                  props={props}
                  getRecipient={getRecipient}
                  updateState={updateState}
                />
                {user?.tenant_info?.is_e_way_bill_enabled && !selectedDC?.e_way_bill_number && Number(selectedDC?.challan_grand_total) >= 50000 && selectedDC?.sales_order_info?.order_type !== 'ANNUAL_MAINTENANCE_CONTRACT' && selectedDC?.status === 'CONFIRMED' && (
                  <div
                    style={{
                      marginBottom: '6px',
                    }}
                  >
                    <Alert
                      message="For transactions over INR 50,000, an e-Way Bill is mandatory."
                      type="warning"
                      showIcon
                    />
                  </div>
                )}
                <ViewDCLeftSectionDocDetails
                  props={props}
                  state={state}
                  getRecipient={getRecipient}
                  updateState={updateState}
                />
                {
                  selectedDC?.e_way_bills?.length && (
                    <ViewDocumentEwb
                      eWayBills={selectedDC?.e_way_bills}
                      actionCallback={() => {
                        getDCById(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.DELIVERY_CHALLAN, Helpers.permissionTypes.READ).join(','), selectedDCId || match.params?.dcId);
                      }}
                    />
                  )
                }
                <ViewDCLeftSectionAddress
                  props={props}
                  state={state}
                  updateState={updateState}
                  getRecipient={getRecipient}
                />
                <br />
                <DCLines dcLines={dataForViewDCLines?.map(item => ({ ...item, lineCustomFields: item?.custom_fields })) || []} selectedDC={selectedDC} updateData={(data) => updateState({ dataForViewDCLines: data })} cfDeliveryChallanLine={cfDeliveryChallanLine} />
                <ViewDCFooter
                  props={props}
                  state={state}
                  updateState={updateState}
                />
              </div>
            </div>
            <ViewDocRightSection
              entityType='DELIVERY_CHALLAN'
              entityId={selectedDC?.delivery_challan_id}
              MONEY={MONEY}
              user={user}
              isQuickView={isQuickView}
              tagSelectorProps={{
                isEnabled: false,
              }}
              workflowTimelineProps={{
                isEnabled: selectedDC?.status?.toLowerCase() !== 'draft',
                workflowSteps: selectedDC?.workflow_steps || [],
                workflowStepId: selectedDC?.workflow_step_id,
                loading: updateDCWorkflowStepLoading,
                updateStep: updateDCWorkflowStep,
                hideCase: HideAdhocApprovals(),
                callback: () => {
                  getDCById(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.DELIVERY_CHALLAN, Helpers.permissionTypes.READ).join(','), selectedDC?.delivery_challan_id || selectedDCId || match?.params?.dcId);
                },
              }}
              activityLogProps={{
                isEnabled: selectedDC,
                entityType: "delivery_challan",
                entityName: "Delivery Challan",
              }}
              linkedDocumentsInfo={getLinkedDocumentInfo()}
            />
          </div>
        )
        : (
          //  Loader
          <ViewLoadingSkull isQuickView={isQuickView} fixedMenuBar={fixedMenuBar} />
        )}
      <PRZDrawer
        onClose={() => updateState({ showDCDrawer: false })}
        open={showDCDrawer}
        width={1050}
        headerWidth={1000}
        title='Update Delivery Challan'
        destroyOnClose
      >
        {selectedDC?.stock_transfer_id ? (
          <DeliveryChallanForm
            edit
            selectedSt={{
              ...selectedDC,
              gst_number: updatedGstNumber,
              stock_transfer_lines: dataForViewDCLines,
            }}
            callback={() => {
              updateState({ showDCDrawer: false });
              getDCById(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.DELIVERY_CHALLAN, Helpers.permissionTypes.READ).join(','), selectedDC?.delivery_challan_id || match.params?.dcId);
            }}
            disableCaseForGST={!selectedDC?.e_way_bills?.filter((rec) => rec?.status === 'GENERATED')?.length}
          />
        ) : (
          <DeliveryChallanForm
            edit
            selectedInvoice={{
              ...selectedDC,
              gst_number: updatedGstNumber,
              delivery_challan_lines: dataForViewDCLines,
            }}
            callback={() => {
              updateState({ showDCDrawer: false });
              getDCById(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.DELIVERY_CHALLAN, Helpers.permissionTypes.READ).join(','), selectedDC?.delivery_challan_id || match.params?.dcId);
            }}
          />
        )}
      </PRZDrawer>
      <PRZDrawer
        open={showEWaybillFormDrawer}
        onClose={() => updateState({ showEWaybillFormDrawer: false })}
        width={520}
        headerWidth={475}
        title='Create e-Way Bill'
        destroyOnClose
      >
        <EwaybillForm
          drawermode
          selectedDocument={selectedDC}
          selectedDocumentId={selectedDC?.delivery_challan_id}
          selectedDocumentNumber={selectedDC?.dc_number}
          selectedDocType={selectedDocType || 'CHL'}
          documentDate={selectedDC?.dc_date}
          callback={() => {
            getDCById(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.DELIVERY_CHALLAN, Helpers.permissionTypes.READ).join(','), selectedDCId || selectedDC?.delivery_challan_id);
            updateState({ showEWaybillFormDrawer: false });
          }}
          entityType="DC"
        />
      </PRZDrawer>
      <PRZDrawer
        onClose={() => updateState({ showNewInvoiceForm: false })}
        open={showNewInvoiceForm}
        width={1250}
        headerWidth={1200}
        title='Create Invoice'
        destroyOnClose
      >
        <InvoiceForm
          selectedOrderForInvoice={{
            ...selectedDC,
            is_line_wise_discount: true,
          }}
          callback={() => {
            getDCById(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.DELIVERY_CHALLAN, Helpers.permissionTypes.READ).join(','), selectedDCId || selectedDC?.delivery_challan_id);
            updateState({ showNewInvoiceForm: false });
          }}
          PaddingTop="false"
          isCarryForward={true}
          selectedDCForInvoice
        />
      </PRZDrawer>
    </div>
  );
};

const mapStateToProps = ({
  UserReducers, DCReducers, AttachmentReducers,
}) => ({
  MONEY: UserReducers.MONEY,
  user: UserReducers.user,
  getDCByIdLoading: DCReducers.getDCByIdLoading,
  selectedDC: DCReducers.selectedDC,
  updateDCStatusLoading: DCReducers.updateDCStatusLoading,
  deleteDCLoading: DCReducers.deleteDCLoading,
  selectedAttachment: AttachmentReducers.selectedAttachment,
  getAttachmentByIdLoading: AttachmentReducers.getAttachmentByIdLoading,
  updateAttachmentLoading: AttachmentReducers.updateAttachmentLoading,
  priceMasking: UserReducers.priceMasking,
  updateDCWorkflowStepLoading: DCReducers.updateDCWorkflowStepLoading,
  updateDeliveryChallanStatusLoading: DCReducers.updateDeliveryChallanStatusLoading,
  quickUpdateDeliveryChallanLoading: DCReducers.quickUpdateDeliveryChallanLoading,
});

const mapDispatchToProps = (dispatch) => ({
  updateDCStatus: (payload, callback) => dispatch(DCActions.updateDCStatus(payload, callback)),
  deleteDC: (payload, callback) => dispatch(DCActions.deleteDC(payload, callback)),
  getDCById: (tenantId, dcId, callback) => dispatch(DCActions.getDCById(tenantId, dcId, callback)),
  getDCByIdSuccess: (selectedDC) => dispatch(DCActions.getDCByIdSuccess(selectedDC)),
  getAttachmentById: (entityId, entityName, callback) => dispatch(AttachmentActions.getAttachmentById(entityId, entityName, callback)),
  updateAttachment: (payload, callback) => dispatch(AttachmentActions.updateAttachment(payload, callback)),
  downloadDocument: (payload, document) => dispatch(AnalyticsActions.downloadDocument(payload, document)),
  updateDCWorkflowStep: (payload, callback) => dispatch(DCActions.updateDCWorkflowStep(payload, callback)),
  updateDeliveryChallanStatus: (payload, callback) => dispatch(DCActions.updateDeliveryChallanStatus(payload, callback)),
  quickUpdateDeliveryChallan: (payload, callback) => dispatch(DCActions.quickUpdateDeliveryChallan(payload, callback)),
  quickUpdateEntityWise: (payload, Callback, rollback) => dispatch(quickUpdateActions.quickUpdateEntityWise(payload, Callback, rollback)),
  getActivityLog: (entityId, entityName, page, limit, callback) => dispatch(ActivityLogActions.getActivityLog(entityId, entityName, page, limit, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ViewDeliveryChallan));